module.exports = function(comments) {
	'use strict';
  comments
  .controller('highlightWordsController', highlightWordsController)
	highlightWordsController.$inject = ["config","$state","API_URL","$stateParams","$http","$rootScope","refreshtokenService","alertService","putDataService","serverError", "offlineError"];
	
  function highlightWordsController(config,$state,API_URL,$stateParams,$http,$rootScope,refreshtokenService,alertService, putDataService,serverError, offlineError) {
    var vmhwc = this;
    vmhwc.highlightWordsArray =  [];
    config.highlightWordsBase.forEach(function(item,index){
      vmhwc.highlightWordsArray.push({word:item,index:index+1})
    })
    vmhwc.highlightWordsCheckbox = config.highlightWordsActive
    if(window.innerWidth<600) {
      var numberOfColumn = 1
    } else if(window.innerWidth>=600 && window.innerWidth<995) {
      var numberOfColumn = 2
    } else {
      var numberOfColumn = 4
    }
    function createHighlightWordsColum(array) {
        if(!array || array.length == 0) return
        vmhwc.highlightWordsArrayPrepared = []
        if(numberOfColumn != 1) {
          if(array.length%numberOfColumn ==0) {
            var numItemsperColumn = array.length/numberOfColumn
          } else {
            var numItemsperColumn = Math.floor(array.length/numberOfColumn) + 1
          }
          for(var i = 0;i<numberOfColumn;i++) {
            vmhwc.highlightWordsArrayPrepared[i] = []
          }
        } else {
          vmhwc.highlightWordsArrayPrepared[0] = []
        }
        var indexOfColumn;
        array.forEach(function(item,index){
          if(numberOfColumn != 1) {
            indexOfColumn = Math.floor(index/numItemsperColumn)
          } else {
            indexOfColumn = 0
          }
          vmhwc.highlightWordsArrayPrepared[indexOfColumn].push({word:item.word,index:item.index})
        })
    }
    createHighlightWordsColum(vmhwc.highlightWordsArray)
    vmhwc.removeWord = function(index) {
      var arrayIndex = vmhwc.highlightWordsArray.findIndex(function(obj) { 
       return obj.index === index
      });
      if (arrayIndex > -1) {
        vmhwc.highlightWordsArray.splice(arrayIndex,1)
      }
      if(vmhwc.searchData) {
        vmhwc.changeSearch(vmhwc.searchData)
      } else {
        createHighlightWordsColum(vmhwc.highlightWordsArray)
      }
    }
    vmhwc.addNewHighlightWord = function(newWord) {
      var index = vmhwc.highlightWordsArray.findIndex(function(obj) {
        return obj.word.toLowerCase() === newWord.toLowerCase();
      });
      if(index !== -1){
        alertService('danger','Opps! ', 'Word alredy exsist');
      } else {
        vmhwc.highlightWordsArray.push({word:newWord})
        vmhwc.highlightWordsArray.sort(function(a,b){
          return a.word.toLowerCase() > b.word.toLowerCase() ? 1 : -1; 
        })
        vmhwc.highlightWordsArray.forEach(function(item,index){
          item.index = index+1
        })
        alertService('success','Success ', 'The word was added', 2000);
        if(vmhwc.searchData) {
          vmhwc.changeSearch(vmhwc.searchData)
        } else {
          createHighlightWordsColum(vmhwc.highlightWordsArray)
        }
      }
    }
    vmhwc.changeSearch = function(searchData) {
      if(!vmhwc.highlightWordsArray || vmhwc.highlightWordsArray.length == 0) return
      var filteredArray = vmhwc.highlightWordsArray.filter(function(item){
        return item.word.toLowerCase().includes(searchData.toLowerCase())
      })
      if(filteredArray && filteredArray.length>0) {
        vmhwc.noSerachResult = false
        createHighlightWordsColum(filteredArray)
      } else {
        vmhwc.noSerachResult = true
      }
    }
    vmhwc.saveChanges = function() {
      var words = []
      vmhwc.highlightWordsArray.forEach(function(item){
        words.push(item.word)
      })
      var saveWWords = {
          'active':vmhwc.highlightWordsCheckbox,
          'words': words
      }
      var putFunction = function() {
        $http.put(API_URL + 'comments/highlightWords', saveWWords)
        .success(function (data, status, headers) {
          alertService('success','Success ', data.message, 2000);
          config.getHighlightWords(saveWWords)
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError();
          } else {  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
          }
        });
      }
      putFunction();
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/commentsModule/highlightWords/js/highlightWordsController.js
// module id = 498
// module chunks = 0